import React, { useState } from "react";
import "./contact.css";
import emailjs from "emailjs-com";
import AppLayout from "../App";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", msg: "" });

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

function handleSubmit(e) {
  e.preventDefault();

  if (!form.name || !form.email || !form.message) {
    setStatus({ type: "error", msg: "Please fill in all required fields." });
    return;
  }

  emailjs
    .send(
      "service_zb6evsq",
      "template_jsejdya",
      {
        name: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
      },
      "Nlai8xTtHy55umya_"
    )
    .then(
      () => {
        setStatus({ type: "success", msg: "Thank you. Your message has been sent." });
        setForm({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      },
      () => {
        setStatus({ type: "error", msg: "Something went wrong. Please try again later." });
      }
    );
}

  return (
    <AppLayout>
      <main className="contact-page">
        <header className="contact-hero">
          <h1 className="contact-title">Contact</h1>
          <p className="contact-subtitle">
            Reach out with your questions or to book a free initial 30-minute consultation.
          </p>
        </header>

        <section className="contact-card">
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="field">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                autoComplete="name"
              />
            </div>

            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="your@email.com"
                autoComplete="email"
              />
            </div>

            <div className="field">
              <label htmlFor="subject">Subject</label>
              <input
                id="subject"
                name="subject"
                type="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder="Subject"
                autoComplete="subject"
              />
            </div>

            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Write your message here"
                rows={6}
              />
            </div>

            {status.msg && (
              <p className={`form-status ${status.type === "success" ? "is-success" : "is-error"}`}>
                {status.msg}
              </p>
            )}

            <button className="contact-submit" type="submit">
              Send
            </button>

            <p className="contact-note">
              Sessions are available online in English and in Spanish.
            </p>
          </form>
        </section>
      </main>
    </AppLayout>
  );
}

export default Contact;
